import React, { FC, useState } from 'react';
import {
  ClearRounded,
  VisibilityOffOutlined,
  TimelineRounded,
  RemoveRedEyeOutlined,
  AspectRatioRounded,
  InputRounded,
} from '@mui/icons-material';

import { LinkingPointObjectType, SectionsObjetType } from '../../constructor/types';
import { ItemMenuComponentType, MenuComponent } from '../MenuComponent';
import { EventSelectInput, SelectInputType } from '../../helpers/events';

interface Props {
  positionX: number;
  positionY: number;
  selectedObjectLine?: LinkingPointObjectType | null;
  closeMenu(): void;
  openModalScale(size: number): void;
}
type ActionsType = 'delete' | 'close' | 'add point' | 'scale' | 'input';

export const MenuLine: FC<Props> = ({ positionX, positionY, closeMenu, selectedObjectLine }) => {
  const [visibleDimensions] = useState(() => {
    if (selectedObjectLine && selectedObjectLine.dimensionObject) {
      return selectedObjectLine.dimensionObject.visible;
    }
    return false;
  });
  const addingControlPoint = () => {
    if (selectedObjectLine) {
      const parent = selectedObjectLine.parent as SectionsObjetType;
      parent.splitLineTwo(selectedObjectLine);
    }
  };
  const dimensions = () => {
    if (selectedObjectLine && selectedObjectLine?.dimensionObject) {
      selectedObjectLine.dimensionObject.visible = !selectedObjectLine.dimensionObject.visible;
      selectedObjectLine.dimensionObject.setVisible();
    }
  };
  const selectInput = () => {
    if (selectedObjectLine) {
      const text =
        selectedObjectLine.startPoint.symbolPoint + selectedObjectLine.endPoint.symbolPoint;
      document.dispatchEvent(
        new CustomEvent<SelectInputType>(EventSelectInput, { detail: { nameSide: text } })
      );
    }
  };
  /*const handleOpenModalScale = () => {
    if (selectedObjectLine) {
      const p1 = selectedObjectLine.startPoint.position;
      const p2 = selectedObjectLine.endPoint.position;
      openModalScale(Math.round(p1.distanceTo(p2)));
    }
  };*/

  const itemsMenu: Array<ItemMenuComponentType<ActionsType>> = [
    {
      title: 'delete',
      icon: !visibleDimensions ? <RemoveRedEyeOutlined /> : <VisibilityOffOutlined />,
      onClickMenuItem: dimensions,
    },
    { title: 'scale', icon: <AspectRatioRounded /> },
    { title: 'add point', icon: <TimelineRounded />, onClickMenuItem: addingControlPoint },
    { title: 'input', icon: <InputRounded />, onClickMenuItem: selectInput },
    { title: 'close', icon: <ClearRounded /> },
  ];

  return (
    <MenuComponent
      closeMenu={closeMenu}
      positionX={positionX}
      positionY={positionY}
      itemsMenu={itemsMenu}
    />
  );
};
